import { Button, Center, Modal, ScrollView, Text } from 'native-base'
import React from 'react'

import { useAuth } from '../../context/auth'

export interface ForceLoginModalProps {
  isOpen: boolean
  maxSessionsToken: string | null
  onForceLoginSuccess: () => void
  onForceLoginError: () => void
  onClose: () => void
  buttonTestID?: string
}

type Props = ForceLoginModalProps & {
  image: JSX.Element
  title: string
  message: string
  confirmButton: string
}

export const BaseForceLoginModal: React.FC<Props> = ({
  isOpen,
  maxSessionsToken,
  onForceLoginSuccess,
  onForceLoginError,
  onClose,
  image,
  title,
  message,
  confirmButton,
  buttonTestID,
}) => {
  const auth = useAuth()
  const [isLoading, setIsLoading] = React.useState(false)

  return (
    <Modal size="full" isOpen={isOpen} onClose={onClose}>
      <Modal.Content padding={4} alignItems="center">
        <ScrollView>
          <Modal.CloseButton />
          <Center>{image}</Center>
          <Text textAlign="center" fontWeight="bold" fontSize="xl" mt={6} mb={2}>
            {title}
          </Text>
          <Text textAlign="center" fontSize="md" color="gray.700" mb={8}>
            {message}
          </Text>
          <Button
            colorScheme="primary"
            onPress={async () => {
              if (maxSessionsToken) {
                try {
                  setIsLoading(true)
                  await auth.forceLogin(maxSessionsToken)
                  onForceLoginSuccess()
                } catch (error) {
                  setIsLoading(false)
                  onForceLoginError()
                }
              }
            }}
            testID={buttonTestID}
            isLoading={isLoading}
            alignSelf="stretch"
          >
            {confirmButton}
          </Button>
        </ScrollView>
      </Modal.Content>
    </Modal>
  )
}
